const formattedIntegerOptions: Intl.NumberFormatOptions = {
	maximumFractionDigits: 0,
	minimumFractionDigits: 0,
	useGrouping: true,
};

const integerFormatter = new Intl.NumberFormat('da', formattedIntegerOptions);

export function getFormattedInteger(value: number): string {
	return integerFormatter.format(value);
}

const currencyOptions: Intl.NumberFormatOptions = {
	maximumFractionDigits: 2,
	minimumFractionDigits: 2,
	currency: 'DKK',
	style: 'currency',
	useGrouping: true,
};

const currencyFormatter = new Intl.NumberFormat('da', currencyOptions);

export function getAsCurrency(value: number): string {
	return currencyFormatter.format(value);
}
